<template>
  <b-container>
    <div>
      <h1 v-if="fill == false">Preenchidos</h1>
    </div>
    <b-row class="mb-3 ml-0">
      <checklist-filled-export
        :fields="fields"
        :table-filters="tableFilters"
        :pagination-per-page="tablePerPage"
      >
      </checklist-filled-export>
    </b-row>
    <!-- {{tableFilters}} -->
    <div v-if="fill == false">
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="getChecklistFilled"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
      <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div v-if="tableFilters[field.key] != null">
                <b-form-input
                  v-if="field.key != 'dateFill'"
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
              <div v-if="field.key == 'dateFill'">
                <base-filter-date
                  ref="baseFilterDate"
                  :dateFill.sync="tableFilters.dateFill"
                  :dateBegin.sync="tableFilters.dateBegin"
                  :dateEnd.sync="tableFilters.dateEnd"
                  :filterName.sync="field.label"
                  :optionFilterDate.sync="optionFilterDate"
                  v-model="tableFilters[field.key]"
                ></base-filter-date>
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <b-col class="buttons">
            <!-- {{data.item}} -->
            <router-link
              :to="
                '/module/form/details/' +
                moduleId +
                '/' +
                data.item.checklistId +
                '/' +
                itemId
              "
            >
              <b-button size="sm">{{ $t("geral.detalhes") }}</b-button>
            </router-link>
          </b-col>

        </template>
      </b-table>

      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </div>
    <!-- <div>{{ id }}</div> -->
  </b-container>
</template>
<script>
export default {
  name: "ModuleViewForm",
  props: {
    id: Number,
    moduleId: String,
    itemId: String,
  },
  components: {
    ChecklistFill: () =>
      import("@/components_rms/checklist/fill/ChecklistFill.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    ChecklistFilledExport: () => import("@/pagesRms/checklist/checklist/ChecklistFilledExport.vue"),
  },
  data() {
    return {
      apiFilter: {
        currentPage: 1,
        perPage: 10,
        checklistId: null,
        formName: null,
        formSearchKey: null,
        dateFill: null,
        fillDateBegin: null,
        fillDateEnd: null,
        fillUserName: null,
        checklistStatus: null,
        formId: this.id,
      },
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      form: {},
      filled: {},
      fill: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "checklist-filled-table-col-buttons",
        },
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Checklist",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "formSearchKey",
          filterKey: "formSearchKey",
          sortable: true,
          label: "Chave de busca",
        },
        {
          key: "formName",
          filterKey: "formName",
          sortable: true,
          label: "Formulário",
        },
        {
          key: "dateFill",
          filterKeyBegin: "dateBegin",
          filterKeyEnd: "dateEnd",
          filterType: "dateRange",
          sortable: true,
          label: "Data preenchimento",
          formatter: (value, key, item) => {
            let date = new Date(item.dateFill);
            return date.toLocaleString();
          },
        },
        {
          key: "checklistStatus",
          filterKey: "checklistStatus",
          sortable: true,
          label: "Status",
        },
        {
          key: "userFillName",
          filterKey: "userFillName",
          sortable: true,
          label: "Responsável preenchimento",
        },
      ],
      tableFilters: {
        checklistId: "",
        formName: "",
        formSearchKey: "",
        dateFill: "",
        checklistStatus: "",
        userFillName: "",
        dateEnd: "",
        dateBegin: "",
        formId: this.id,
      },
      optionFilterDate: 0,
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  methods: {
    getChecklistFilled(ctx, callback) {
      console.log("ctx")
      console.log(ctx)
      this.apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        checklistId: ctx.filter.checklistId,
        formName: ctx.filter.formName,
        formSearchKey: ctx.filter.formSearchKey,
        dateFill: ctx.filter.dateFill,
        fillDateBegin: ctx.filter.dateBegin,
        fillDateEnd: ctx.filter.dateEnd,
        fillUserName: ctx.filter.userFillName,
        checklistStatus: ctx.filter.checklistStatus,
        formId: ctx.filter.formId,
      };
      this.$apiChecklist
        .post("/checklist/all", this.apiFilter)
        .then((response) => {
          this.filled = response.data.items;
          // console.log(response);
          const items = this.filled;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
          this.$forceUpdate;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error);
          console.log(error.response.data.errors);

          return null;
        });
    },
  },
  watch: {
    id() {
      this.getChecklistFilled();
    },
  },
};
</script>
<style>
.checklist-filled-table-col-buttons {
  width: 130px;
}
.dateFilter {
  margin-bottom: 10px;
}
.vertical-align {
  vertical-align: bottom !important;
}
</style>